export default {
  wxConfig: null,
  userInfo: {}, //  用户信息
  origanization: [], //  组织结构
  headerInfo: {}, // header的标题
  globalData: {}, // 全局数据
};
